import script from "./UserAddedTag.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAddedTag.vue?vue&type=script&setup=true&lang=js"

import "./UserAddedTag.vue?vue&type=style&index=0&id=c786c28e&scoped=true&lang=scss"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c786c28e"]])

export default __exports__